import { useLocation, useSearchParams } from 'react-router-dom';

const useQuerySearchParams = () => {
  const { search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const queryObject = new URLSearchParams(search);

  const setParam = (name: string, value: string) => {
    queryObject.set(name, value);
    setSearchParams(queryObject.toString());
  };

  const getParam = (key: string) => searchParams.get(key);

  return { setParam, getParam };
};

export default useQuerySearchParams;
